<template>
  <section>
    <mdb-row>
      <mdb-col col="12" class="d-flex justify-content-center">
        <mdbCard class="login_form_container">
          <mdbCardBody>
            <form @submit.prevent="login()">
              <p class="h4 text-center mb-4">
                Please Login
              </p>
              <div class="grey-text">
                <mdbInput
                  v-model="email"
                  v-model.trim="email"
                  label="Your email"
                  icon="envelope"
                  type="email"
                />
                <mdbInput
                  v-model="password"
                  v-model.trim="password"
                  label="Your password"
                  icon="lock"
                  type="password"
                />
                <span v-show="error" class="red-text">{{ error }}</span>
              </div>
              <div class="text-center">
                <mdb-btn size="lg" class="login-button">
                  Login
                </mdb-btn>
              </div>
            </form>
          </mdbCardBody>
        </mdbCard>
      </mdb-col>
    </mdb-row>
  </section>
</template>

<script>
import { mdbInput, mdbBtn, mdbCard, mdbCardBody, mdbRow, mdbCol } from "mdbvue";
import { userService } from "../services/user.service";

export default {
  name: "Login",
  components: {
    mdbCard,
    mdbBtn,
    mdbInput,
    mdbCardBody,
    mdbRow,
    mdbCol
  },
  data() {
    return {
      email: "",
      password: "",
      error: ""
    };
  },
  methods: {
    login() {
      return userService
        .login(this.email, this.password)
        .then(() => this.$router.push("/"))
        .catch(error => (this.error = error.message));
    }
  }
};
</script>
<style scoped>
.login-button {
  background-color: #085408 !important;
}
.md-form input:focus {
  border-bottom: 1px solid #085408;
  -webkit-box-shadow: 0 1px 0 0 #085408;
  box-shadow: 0 1px 0 0 #085408;
}
.login_form_container{
  width: 650px;
}
</style>
